import React from "react";
import logo from "./assets/epvectorlogo.svg";
import "./App.css";

function App() {
  return (
    <div className='App background-image'>
      <header className='App-header'>
        <img src={logo} className='App-logo' alt='logo' />
        <div className='info-section'>
          <p>Web sitemiz bakımdadır. </p>
          <p>En kısa sürede tekrar sizlerle olacağız.</p>
        </div>
        <div className='info-container'>
          <p className='info-section'>
            Email:{" "}
            <a href='mailto:info@elektropanc.com.tr' className='mail-link'>
              info@elektropanc.com.tr
            </a>
          </p>
          <p className='info-section'>Telefon: +90 212 222 83 83</p>
        </div>
      </header>
    </div>
  );
}

export default App;
